import React, { useState, useEffect, Suspense } from 'react';
import loader from './components/shared/Loader';
import { Route, Routes } from 'react-router-dom'
import routes from './routes';
import UserContext from './business/referential/UserContext';
import ContentReferential from './business/referential/ContentReferential';
import Client from './api/client';
//import "./assets/css/main.scss";
//import './custom.css'

function App(props) {
  const [data, setData] = useState(null);
  const [isReady, setReady] = useState([]);


  useEffect(() => {
    const process = async () => {
      if (sessionStorage.getItem("bearer") === null) {
        window.location.href = "/";
      }

      if (sessionStorage.getItem("contentRef") === null) {
        await ContentReferential.loadRef().then(result => { sessionStorage["contentRef"] = result; });
      }

      var user = JSON.parse(sessionStorage["auth"]);
      var r = JSON.parse(sessionStorage["contentRef"]);

      if (sessionStorage.getItem("context") === null) {
        var datas = { dataContent: r, userObject: user };

        setData(data => data = datas);
        setReady(isReady => isReady = true);
        sessionStorage["context"] = JSON.stringify(datas);
      }
      else {
        var datas = JSON.parse(sessionStorage["context"]);
        if (datas.dataContent === null) {
          datas.dataContent = r;
          datas.userObject = user;
          sessionStorage["context"] = JSON.stringify(datas);
        }
        setData(data => data = datas);
        setReady(isReady => isReady = true);
      }
    }
    process();
  }, []);


  return (
    <>
      <Suspense fallback={loader()}>
        {isReady && data !== null &&
          <UserContext.Provider value={data}>
            <Routes>
              {routes.map((route, index) => {
                return (route.component) ? (
                  <Route
                    key={index}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    element={
                      <route.component SubComponent={route.subcomponent} {...props} />
                    }></Route>
                ) : (null);
              })}
            </Routes>
          </UserContext.Provider>
        }
      </Suspense>
    </>
  );
}

export default App;